import { Language } from './language.model';

/** The part of a backend `LanguageDto` the helpers need; each app generates its own DTO. */
export interface DocumentLanguageLike {
  code: string;
  name?: string;
}

const FALLBACK_DOCUMENT_LANGUAGE = 'en-us';

const DOCUMENT_LANGUAGE_BY_INTERFACE: Record<Language, string> = {
  en: 'en-us',
  'be-nl': 'nl-be',
  nl: 'nl-nl',
  fr: 'fr-be',
};

export function resolveDocumentLanguage<T extends DocumentLanguageLike>(
  languages: T[],
  interfaceLanguage: Language
): T | undefined {
  const findByCode = (target: string): T | undefined =>
    languages.find(({ code }) => code.toLowerCase() === target);

  return findByCode(DOCUMENT_LANGUAGE_BY_INTERFACE[interfaceLanguage])
    ?? findByCode(FALLBACK_DOCUMENT_LANGUAGE);
}

export function documentLanguageLabelKey(code: string): string {
  return `DOCUMENT_LANGUAGES.${code.toUpperCase()}`;
}

export function getDocumentLanguageLabel(
  language: DocumentLanguageLike,
  translate: (key: string) => string
): string {
  const key = documentLanguageLabelKey(language.code);
  const label = translate(key);

  return label !== key ? label : language.name || language.code;
}
